export class ShoppingCartMapper {
    public static findCharacteristicsByOption(
        item: OrderTrackerBackend.CartItem,
        option: OrderTrackerBackend.Option,
    ): OrderTrackerBackend.CartItem[] {
        const optionParent: OrderTrackerBackend.CartItem | undefined = ShoppingCartMapper.findItem(
            item,
            option.parentType,
            (cartItem) => cartItem.id === option.parentId,
        );
        const characteristics: OrderTrackerBackend.CartItem[] = (optionParent && optionParent.characteristics) || [];

        return characteristics.filter((characteristic) => characteristic.name === option.name);
    }

    public static findProduct(
        shoppingCart: OrderTrackerBackend.ShoppingCart,
        productName: string,
        nested?: boolean,
    ): OrderTrackerBackend.CartItem | undefined {
        // (!) product name is swapped with description in backend
        if (!nested) {
            return shoppingCart.products.find((product) => product.description === productName);
        }
        return shoppingCart.products
            .map((product) =>
                product.description === productName
                    ? product
                    : // TODO: use enum for 'PRODUCT' when "dtsgenerator" library adds option to generate interfaces with enums
                      //  https://github.com/horiuchi/dtsgenerator/issues/335
                      ShoppingCartMapper.findItem(product, 'PRODUCT', (item) => item.description === productName),
            )
            .find(Boolean);
    }

    private static findItem(
        rootItem: OrderTrackerBackend.CartItem,
        type: OrderTrackerBackend.Option['parentType'],
        match: (item: OrderTrackerBackend.CartItem) => boolean,
    ): OrderTrackerBackend.CartItem | undefined {
        if (rootItem.type === type && match(rootItem)) {
            return rootItem;
        }

        const childItems: OrderTrackerBackend.CartItem[] = [
            ...rootItem.products,
            ...rootItem.services,
            ...rootItem.resources,
            ...rootItem.characteristics,
        ];

        const matchedItems = childItems
            .map((childItem) => ShoppingCartMapper.findItem(childItem, type, match))
            .filter(Boolean);

        if (matchedItems.length > 1) {
            throw Error('Illegal state, expected to match single or no item');
        }

        return matchedItems[0];
    }
}
